export default {
    suppliers: {
        loading: false,
        error: false,
        noContent: false,
        supplier: undefined,
        suppliers: undefined,
    },
    availability: {
        loading: false,
        error: false,
        noContent: false,
        items: undefined,
        accommodation: undefined
    },
    notifications: {
        page: 1,
        limit: 5,
        limits: [5,10,20,50],
        loading: false,
        error: false,
        noContent: false,
        items: undefined,
        filters: {
            site: undefined,
            accommodation: undefined,
            predicate: undefined,
            predicates: [
                'soldOut',
                'stay',
                'arrival',
                'released'
            ]
        },
        dismiss: {
            loading: false,
            error: false,
            noContent: false
        }
    },
    dashboardPage: {
        tricks: [
            "allocation",
            "statistics"
        ],
        tips: [
            {
                title: 'tips.dashboardPage.graph.title',
                body: 'tips.dashboardPage.graph.body'
            },
            {
                title: 'tips.dashboardPage.notifications.title',
                body: 'tips.dashboardPage.notifications.body'
            },
            {
                title: 'tips.dashboardPage.add.title',
                body: 'tips.dashboardPage.add.body'
            },
            {
                title: 'tips.dashboardPage.filter.title',
                body: 'tips.dashboardPage.filter.body'
            }
        ]
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/dashboard/state.js